<template>
  <el-table
    :height="height"
    v-if="show"
    :data="tableData" class="fireTable" :class="tabindex === 3 ? 'fireTable2' : 'fireTable1'" stripe>
    <el-table-column
      prop="date"
      align="center"
      width="80"
      label="序号">
      <template slot-scope="scope">
        <span>{{ scope.$index + 1 }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="(item, i) in column"
      :prop="item.prop"
      :key="i"
      align="center"
      :sortable="item.sort"
      :min-width="item.width"
      :label="item.label">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "fire",
  props: {
    tableData: {type: Array, default: () => []},
    height: {type: Number, default: 600},
    tabindex: {type: Number, default: 3},
    show: { type: Boolean, default: true }
  },
  data() {
    return {
      column1: [
        {label: '乡镇名称', prop: 'townName', width: '140'},
        {label: '火点报警', prop: 'totalCount', width: '146', sort: true},
        {label: '超时次数', prop: 'overtimeCount', width: '100', sort: true},
        {label: '最长处理时长（min）', prop: 'maxProcessTime', width: '120', sort: true},
        {label: '平均时长（min）', prop: 'averageProcessTime', width: '100', sort: true}
      ],
      column2: [
        {label: '乡镇名称', prop: 'townName', width: '95'},
        {label: '火点报警', prop: 'totalCount', width: '70', sort: true},
        {label: '已处理', prop: 'processedCount', width: '60', sort: true},
        {label: '未处理', prop: 'unprocessedCount', width: '60', sort: true},
        {label: '超时次数', prop: 'overtimeCount', width: '100', sort: true},
        {label: '最长处理时长（min）', prop: 'maxProcessTime', width: '120', sort: true},
        {label: '平均时长（min）', prop: 'averageProcessTime', width: '100', sort: true}
      ],
      column: []
    }
  },
  mounted() {
    this.getColumn()
  },
  watch: {
    tabindex() {
      this.getColumn()
    }
  },
  methods: {
    getColumn() {
      if (this.tabindex === 3) {
        this.column = this.column2
      } else {
        this.column = this.column1
      }
    }
  }
}
</script>

<style scoped lang="less">
.fireTable {
  width: 100%;
  background-color: #003347 !important;
  border-bottom: 0 !important;

  &::before {
    background-color: rgba(255, 255, 255, 0) !important;
  }

  .el-table__cell .gutter {
    width: 0px !important;
  }

  /deep/ .el-table__body {
    width: 100% !important;
  }


  /deep/ .el-table__body-wrapper {
    &::-webkit-scrollbar {
      display: none;
      width: 0;
    }
  }

  /deep/ tbody {
    tr {
      background-color: #003347 !important;
    }
  }
}
.fireTable1 {
  /deep/ th, .el-table__cell {
    font-weight: bold;
    background-color: #00606E;
    border-bottom: 0 !important;
    font-size: 20px;
    color: #FFFFFF;
    padding: 0;
    height: 60px;
    line-height: 34px;

    &:nth-of-type(n+4) {
      background-color: #004970 !important;
    }

    .cell {
      line-height: 60px;
    }
  }


  /deep/ td, .el-table__cell {
    height: 80px;
    color: #FFFFFF;
    border-bottom: 0 !important;
    background-color: #003347 !important;

    &:nth-of-type(n+4) {
      background-color: #002C47 !important;
    }
  }

  /deep/ .el-table__row--striped {
    td {
      background: #00606E !important;

      &:nth-of-type(n+4) {
        background-color: #004970 !important;
      }
    }
  }
}
.fireTable2 {
  /deep/ th, .el-table__cell {
    font-weight: bold;
    background-color: #00606E;
    border-bottom: 0 !important;
    font-size: 20px;
    color: #FFFFFF;
    padding: 0;
    height: 60px;
    line-height: 34px;

    &:nth-of-type(n+6) {
      background-color: #004970 !important;
    }

    .cell {
      line-height: 60px;
    }
  }


  /deep/ td, .el-table__cell {
    height: 80px;
    color: #FFFFFF;
    border-bottom: 0 !important;
    background-color: #003347 !important;

    &:nth-of-type(n+6) {
      background-color: #002C47 !important;
    }
  }

  /deep/ .el-table__row--striped {
    td {
      background: #00606E !important;

      &:nth-of-type(n+6) {
        background-color: #004970 !important;
      }
    }
  }
}

</style>
